import { ILoginUserSuccessResponse } from '../views/Auth/Login/interfaces/IGoogleUser';

type ICaseHandleAuth = 'jwtTokenAndTokenAndNotExpired' | 'tokenAndExpiredTokenAndredirectLogoutUrl' | 'default';

const expiryValidation = (expireIn: number): boolean => {
  const now = Date.now() / 1000;

  return expireIn < now;
};

export const handleCaseAuth = (args: { user?: ILoginUserSuccessResponse; token?: string | null }): ICaseHandleAuth => {
  const { user, token } = args;
  const userExpiration = user?.exp ?? user?.expiresIn ?? 0;

  if (token && user && !expiryValidation(user.exp ?? 0)) {
    return 'jwtTokenAndTokenAndNotExpired';
  }

  if (user && expiryValidation(userExpiration) && user.redirectLogoutUrl) {
    return 'tokenAndExpiredTokenAndredirectLogoutUrl';
  }

  return 'default';
};
